module.exports = {
  stripInline: function(content) {
    content = content.replace(/style=".*?"/g, '');
    content = content.replace(/sizes=".*?"/g, '');
    content = content.replace(/srcset=".*?"/g, '');

    return content;
  },
  formatYouTube: function(content) {
    let iframeRegex = /<iframe.*<\/iframe>/g;

    let YTMatch;
    while ((YTMatch = iframeRegex.exec(content)) !== null) {
      let YT     = YTMatch[0];
      let height  = YT.match(/height="([0-9]*)"/);
      let width   = YT.match(/width="([0-9]*)"/);

      let YTContainer = YT;
      if (height && !isNaN(height[1]) && width && !isNaN(width[1])) {
        let ratio   = ((Math.round(height[1]) / Math.round(width[1])) * 100).toFixed(2);
        YTContainer = `<div class="ytEmbed" style="width: ${width[1]}px;"><div style="padding-top: ${ratio.replace('.00', '')}%;">${YT}</div></div>`;
      }

      content = content.replace(YT, YTContainer);
    }

    return content;
  },
  formatSource: function(content) {
    let httpRegex = /src=("|')http:\/\//g;

    let httpMatch;
    while ((httpMatch = httpRegex.exec(content)) !== null) {
      content = content.replace(httpMatch[0], `src=${httpMatch[1]}https://`);
    }

    return content;
  },
  formatContent: function(content) {
    content = this.formatSource(content);
    content = this.formatYouTube(content);

    return content;
  }
};
